import React from 'react';
import { Box } from '@mui/material'; // Only Box and Typography from MUI
import StatCard from '../../components/StatCard/StatCard';
import RevenueChart from '../../components/RevenueChart/RevenueChart';
import AttendanceChart from '../../components/AttendanceChart/AttendanceChart';
import NewCandidates from '../../components/NewCandidates/NewCandidates';
import ApplicationStatusChart from '../../components/ApplicationStatusChart/ApplicationStatusChart';
import styles from './Dashboard.module.scss'; // Ensure this SCSS module is imported
import { ReactComponent as ApplicationIcon } from "../../assets/icons/kpiicon1.svg";
import { ReactComponent as RevenueIcon } from "../../assets/icons/kpiicon2.svg";
import { ReactComponent as StudentsIcon } from "../../assets/icons/kpiicon3.svg";
import { ReactComponent as ScholarshipIcon } from "../../assets/icons/kpiicon4.svg";
import useDashboard from "./useDashboard"

const Dashboard: React.FC = () => {
  const {data, isLoading, isError} = useDashboard()
  return (
    <Box className={styles.dashboardContainer}>
      <Box className={`${styles.section} ${styles.sectionKpi}`}> {/* This Box will act as a container for stat cards */}
        {/* Stat Cards */}
        <Box className={styles.statCardWrapper}>
          <StatCard cardId="studentstotal" title="Students (Total)" value={data?.total_students_count} color="#6200EE" icon={<ApplicationIcon />} link='' />
        </Box>
        <Box className={styles.statCardWrapper}>
          <StatCard cardId="studentsactive" title="Students (Active)" value={data?.students_count} color="#6200EE" icon={<ApplicationIcon />} link='' />
        </Box>
        <Box className={styles.statCardWrapper}>
          <StatCard cardId="applications" title="New Applications" value={data?.new_applications_count} color="#FF5722" icon={<RevenueIcon />} link='' />
        </Box>
        <Box className={styles.statCardWrapper}>
          <StatCard cardId="pending" title="Pending Interviews" value={data?.pending_interviews_count} color="#03DAC6" icon={<StudentsIcon />} link='' />
        </Box>
        <Box className={styles.statCardWrapper}>
          <StatCard cardId="forecast" title="Forecast for next month" value={data?.forecast} color="#2196F3" icon={<ScholarshipIcon  />} link='' />
        </Box>
        
      </Box>

      <Box className={`${styles.section} ${styles.sectionBody}`}>  
        <Box className={styles.chartRevenueWrapper}>  
          <RevenueChart data={data?.monthly_data || []}/>
        </Box>
        <Box className={styles.chartAttendanceWrapper}>  
          <AttendanceChart data={data?.state_output || []}/>
        </Box>
      </Box>

      <Box className={`${styles.section} ${styles.sectionBody}`}> 
        <Box className={styles.bottomSectionLeftWrapper}> 
          <NewCandidates candidates={data?.new_application || []}/>
        </Box>
        <Box className={styles.bottomSectionRightWrapper}>  
          <ApplicationStatusChart studentRatio={data?.students_per_course}/>
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;